/**
 * 分页符扩展 - 用于在编辑器中插入Word分页符
 */
import { Node, mergeAttributes } from '@tiptap/core';

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    pageBreak: {
      /**
       * 插入分页符
       */
      setPageBreak: () => ReturnType;
    };
  }
}

export const PageBreakNode = Node.create({
  name: 'pageBreak',

  group: 'block',

  atom: true,

  parseHTML() {
    return [
      {
        tag: 'div[data-type="page-break"]',
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return [
      'div',
      mergeAttributes(HTMLAttributes, {
        'data-type': 'page-break',
        'class': 'page-break-node',
      }),
      [
        'div',
        { class: 'page-break-line' },
        [
          'span',
          { class: 'page-break-text' },
          '分页符'
        ]
      ]
    ];
  },

  addCommands() {
    return {
      setPageBreak:
        () =>
        ({ commands }) => {
          return commands.insertContent({
            type: this.name,
          });
        },
    };
  },
});

export default PageBreakNode;
